export default __webpack_public_path__ + "static/media/ic-avg-working-hrs.578cc274.svg";